import { request } from "./request";

// 获取媒体报道的列表
export function getAltlist(model) {
  return request({
    method: "POST",
    url: "api/town/townad/list",
    data: model
  });
}

// 获取媒体报道的列表详情
export function getAltinfoid(id) {
  return request({
    method: "GET",
    url: "api/town/townad/info/" + id
  });
}

// 获取节目类型表列表
export function getAlttypeist(model) {
  return request({
    method: "POST",
    url: "api/town/showtype/list",
    data: model
  });
}

// 获取节目表列表
export function getAlist_pcList(model) {
  return request({
    method: "POST",
    url: "api/town/show/list_pc",
    data: model
  });
}

// 获取节目详情
export function getAlinfo_pc(id, language) {
  return request({
    method: "GET",
    url: "api/town/show/" + id + "/info_pc?language=" + language
  });
}

//获取活动详情
export function getGoods_pc(model) {
  return request({
    method: "post",
    url: "/goods/front/query",
    data: model
  });
}

//获取活动详情
export function getGoods_pc_detail(id) {
  return request({
    method: "get",
    url: `/goods/front/${id}`
  });
}

// 获取节目类型下来列表
export function getselectList() {
  return request({
    method: "GET",
    url: "api/town/showtype/selectList"
  });
}

// 获取轮播图
export function getbaList() {
  return request({
    method: "GET",
    url: `api/town/ad/list?clientType=1&adCode=${'homeTop'}`
  });
}

// 获取轮播图
export function getnewbaList() {
  return request({
    method: "GET",
    url: `api/town/ad/list?clientType=1&adCode=${'webTop'}`
  });
}
//获取帮组中心列表
export function gethelpList(model) {
  return request({
    method: "POST",
    url: "/api/town/townhelpcenter/all",
    data: model
  });
}

//获取帮助中心详情
export function gethelpinfo(id) {
  return request({
    method: "GET",
    url: `/api/town/townhelpcenter/info/${id}`
  });
}

//获取协议
export function getagreelist(key) {
  return request({
    method: "GET",
    url: `/api/town/anon/agreement/list?key=${key}`
  });
}

//获取协议详情
export function getagreeinfo(id, key) {
  return request({
    method: "GET",
    url: `/api/town/anon/agreement/get?id=${id}&key=${key}`
  });
}

//获取会员活动
export function getmemberlist() {
  return request({
    method: "GEt",
    url: `/api/town/anon/activitytype/list`
  });
}

//无票版订单
export function getnopayorder(model, token) {
  return request({
    url: "/api/town/ticket_order/create_ticket_order_not_paper",
    method: "post",
    headers: {
      Authorization: token,
      "client-key": 1
    },
    data: model
  });
}

// 获取日历
export function getCalendar(model, token) {
  return request({
    method: "POST",
    url: "/api/town/session/sessionDates",
    headers: {
      Authorization: token,
      "client-key": 1
    },
    data: model
  });
}
//获取节目
export function getShowList(model, token) {
  return request({
    method: "POST",
    url: "/api/town/show/list_pc",
    headers: {
      Authorization: token,
      "client-key": 1
    },
    data: model
  });
}

// 获取首页媒体报道
export function getMediaReportList() {
  return request({
    method: "GET",
    url: "/api/town/townad/weight/list"
  });
}

// 获取场地凭证
export function getVenueCertification() {
  return request({
    method: "GET",
    url: `/api/town/anon/about/get/49c83418a4e34df08873cfda57b6b35f`
  });
}


//官网获取往期节目表列表
export function getPastShowList(model, token) {
  return request({
    method: "POST",
    url: "/api/town/show/list_pc_previous",
    headers: {
      Authorization: token,
      "client-key": 1
    },
    data: model
  });
}


// 获取有场次的日期列表
export function getShowDateList(model, token) {
  return request({
    method: "POST",
    url: "/api/town/show/list_session_show",
    headers: {
      Authorization: token,
      "client-key": 1
    },
    data: model
  });
}


// WEBPACK FOOTER //
// ./src/network/home.js